/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { NotaryAPI } from '../api/notary/types';
import { CommonAPI } from '../api/common/responses';
import { DocumentsAPI } from '../api/common/documents';
import { notaryAPI } from '../api/notary';
import { participantAPI } from '../api/participant';

// we explicitly couple the selected Doc ID with the selected Doc PDF so that these always change together
// this ensures that any UI relying on the selected Doc ID/PDF is kept in-sync
export const getSelectedDocumentPdfUrl = async (
  documentId: string,
  callDetails: NotaryAPI.CallDetailsResponse | CommonAPI.CallDetailsResponse | null,
  documents: DocumentsAPI.DocumentsResponse,
  isNotary: boolean,
) => {
  const document = documents && documents.find(doc => doc.id === documentId);

  if (!callDetails || !document?.allowDownload) {
    return undefined;
  }

  const fileUrl = isNotary
    ? await notaryAPI.documents.fetchCallDocumentPdf(callDetails.id, documentId)
    : await participantAPI.documents.fetchCallDocumentPdf(callDetails.id, documentId);

  return fileUrl;
};

// we show the room docs in the signing room before the signing starts so we will need to download
// the room document in those instances
export const getSelectedRoomDocumentPdfUrl = async (
  documentId: string,
  roomId: string,
  documents: DocumentsAPI.DocumentsResponse,
) => {
  const document = documents && documents.find(doc => doc.id === documentId);

  if (!document?.allowDownload) {
    return undefined;
  }

  const fileUrl = await notaryAPI.documents.fetchRoomDocumentPdf(roomId, documentId);

  return fileUrl;
};

export const getDocumentPdfUrlForReview = async (documentId: string, callId: string) => {
  return await notaryAPI.documents.fetchCallDocumentPdf(callId, documentId);
};
